var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIllustSimple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 106,
    height: 101,
    viewBox: "0 0 106 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 105.122,
    height: 101,
    rx: 20,
    fill: "#A1CC3A",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.2261 79.0099L83.9558 54.2802M48.027 32.777C48.027 39.8336 42.3066 45.5541 35.25 45.5541C28.1934 45.5541 22.473 39.8336 22.473 32.777C22.473 25.7205 28.1934 20 35.25 20C42.3066 20 48.027 25.7205 48.027 32.777ZM59.5676 20H85.1216V45.5541H59.5676V20ZM34.8378 55.4459L49.6757 81H20L34.8378 55.4459Z",
    stroke: "#A1CC3A",
    strokeWidth: 6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustSimple);
export default __webpack_public_path__ + "static/media/illust-simple.2d36066dc4b41d8a867fd43526da9a78.svg";
export { ForwardRef as ReactComponent };